/**
 * One-call intake assessment (design record Steps 1-2): profile
 * the table, detect the preset, classify the file, detect roles.
 * The app shows the classification with its evidence, the profile
 * summary, and the detected roles for confirmation before any QC
 * or fitting. QC (runQcChecks) and feasibility
 * (previewFeasibility) run next on the confirmed roles.
 */
import { classifyTable } from './classify.js';
import { detectRoles } from './detect.js';
import { detectPreset, presetById } from './presets.js';
import { profileTable } from './profile.js';
export function assessTable(table, options = {}) {
    const baseProfile = profileTable(table);
    const { preset, evidence } = detectPreset(table);
    const chosen = options.presetId !== undefined
        ? (presetById(options.presetId) ?? preset)
        : preset;
    const classification = classifyTable(table, baseProfile);
    // Role detection with the classification. An undetermined file
    // is scored with the microdata role set: its evidence says why,
    // and the scores themselves show what the file could support.
    const { roles, profile } = detectRoles(table, {
        kind: classification.kind,
        preset: chosen,
        profile: baseProfile,
    });
    const roleMap = roles.roles;
    const designFound = [
        roleMap.areaId,
        roleMap.weight,
        roleMap.stratum,
        roleMap.psu,
        roleMap.psuPopulationCount,
    ].filter((v) => v !== undefined).length;
    const areaCol = profile.columns.find((c) => c.name === roleMap.areaId);
    return {
        classification,
        preset: chosen,
        presetEvidence: evidence,
        profile,
        roles,
        summary: {
            rows: profile.rowCount,
            columns: profile.columnCount,
            areasFound: areaCol ? areaCol.distinctCount : null,
            designVariablesFound: designFound,
            indicatorCandidates: roleMap.indicators.length,
            subgroupVariables: roleMap.subgroups.length,
            covariateCandidates: roleMap.covariates.length,
        },
    };
}
//# sourceMappingURL=assess.js.map